import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Save, Calendar } from "lucide-react";
import { apiAuthGet, apiAuthSend } from "@/lib/api";
import Modal, { Field, Input, Textarea, Btn } from "./_ui";

const BLANK = { date: "", note: "" };

export default function ComebackAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(BLANK);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const load = () => apiAuthGet("/admin/comeback").then((d) => setItems([...d].sort((a, b) => a.date.localeCompare(b.date)))).catch((e) => setErr(e.message));
  useEffect(() => { load(); }, []);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      if (editing === "new") await apiAuthSend("POST", "/admin/comeback", form);
      else await apiAuthSend("PUT", `/admin/comeback/${editing}`, form);
      setEditing(null); await load();
    } catch (ex) { setErr(ex.message); }
    finally { setBusy(false); }
  };

  const remove = async (id) => {
    if (!window.confirm("Termin wirklich löschen?")) return;
    await apiAuthSend("DELETE", `/admin/comeback/${id}`);
    await load();
  };

  return (
    <div className="space-y-6" data-testid="admin-comeback">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-400 font-bold mb-1">Content</div>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-white font-[Outfit]">Comeback-Termine</h1>
          <p className="text-slate-400 mt-1.5 text-sm">{items.length} Termine für die Comeback-Aktion</p>
        </div>
        <Btn onClick={() => { setEditing("new"); setForm(BLANK); }} data-testid="comeback-new"><Plus className="w-4 h-4" /> Neuer Termin</Btn>
      </div>

      {err && <div className="rounded-xl bg-red-500/10 border border-red-500/30 p-3 text-sm text-red-300">{err}</div>}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((it) => (
          <div key={it.id} data-testid={`comeback-row-${it.id}`}
            className="rounded-2xl p-5 bg-white/5 border border-white/10 hover:border-emerald-400/30 transition flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-500/15 flex items-center justify-center text-emerald-300 shrink-0">
              <Calendar className="w-5 h-5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-white font-[Outfit] font-mono">{it.date}</div>
              {it.note && <div className="text-xs text-slate-400 mt-1 line-clamp-2">{it.note}</div>}
            </div>
            <div className="flex flex-col gap-1.5">
              <Btn variant="secondary" onClick={() => { setEditing(it.id); setForm({ ...BLANK, ...it }); }} data-testid={`comeback-edit-${it.id}`}>
                <Pencil className="w-3.5 h-3.5" />
              </Btn>
              <Btn variant="danger" onClick={() => remove(it.id)} data-testid={`comeback-delete-${it.id}`}>
                <Trash2 className="w-3.5 h-3.5" />
              </Btn>
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="sm:col-span-2 lg:col-span-3 rounded-2xl bg-white/5 border border-white/10 p-12 text-center text-slate-400">
            <Calendar className="w-8 h-8 mx-auto mb-2 opacity-50" /> Noch keine Comeback-Termine.
          </div>
        )}
      </div>

      <Modal open={!!editing} onClose={() => setEditing(null)} title={editing === "new" ? "Neuer Comeback-Termin" : "Termin bearbeiten"}>
        <form onSubmit={save} className="space-y-4" data-testid="comeback-form">
          <Field label="Datum"><Input required type="date" value={form.date} onChange={onChange("date")} /></Field>
          <Field label="Notiz (intern, optional)"><Textarea rows={2} value={form.note} onChange={onChange("note")} /></Field>
          <div className="flex justify-end gap-2 pt-2">
            <Btn type="button" variant="secondary" onClick={() => setEditing(null)}>Abbrechen</Btn>
            <Btn type="submit" disabled={busy} data-testid="comeback-save"><Save className="w-4 h-4" /> Speichern</Btn>
          </div>
        </form>
      </Modal>
    </div>
  );
}
